import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';

import './i18n';
/*
 * UNA SOLA HOJA. Adentro importa, en orden y en su capa, las ocho de siempre
 * y Tailwind: ver el encabezado de styles-tailwind.css para por qué las capas
 * mandan acá.
 */
import './styles-tailwind.css';
import { App } from './App';
import { InstalarPrimero } from './components/InstalarPrimero';
import { AuthProvider } from './auth/AuthContext';
import { ThemeProvider } from './theme/ThemeProvider';

/*
 * EL SERVICE WORKER, PARA QUE ANDROID PUEDA OFRECER INSTALAR.
 *
 * Chrome no dispara `beforeinstallprompt` si no hay uno registrado con un
 * manejador de `fetch`; el manifest solo no alcanza. Ver `public/sw.js`, que
 * no cachea nada a propósito.
 *
 * FALLA EN SILENCIO Y ESTÁ BIEN: el registro no anda en `file://`, en algunos
 * navegadores viejos y en ventanas privadas. La aplicación funciona igual sin
 * él —lo único que se pierde es el botón de instalar— así que un error acá no
 * tiene que romper el arranque.
 */
if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    void navigator.serviceWorker.register('/sw.js').catch(() => {
      /* Sin service worker no hay botón de instalar, y nada más. */
    });
  });
}

const container = document.getElementById('root');
if (container === null) throw new Error('Falta <div id="root"> en index.html');

createRoot(container).render(
  <StrictMode>
    <ThemeProvider>
      <AuthProvider>
        <BrowserRouter future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
          {/* ENVUELVE A TODO Y VA ACÁ, no adentro de una pantalla: en el
              teléfono la app no se usa sin instalar, así que la puerta tiene
              que estar antes que cualquier ruta —incluida la de entrar—.
              Ver `InstalarPrimero`, que no bloquea ni la computadora ni la
              app nativa de las tiendas. */}
          <InstalarPrimero>
            <App />
          </InstalarPrimero>
        </BrowserRouter>
      </AuthProvider>
    </ThemeProvider>
  </StrictMode>,
);
